import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useApp } from "../context/AppContext";
import {
  Store,
  ListChecks,
  Camera,
  AlertTriangle,
  UserCheck,
  FileSignature,
  CheckCircle2,
  ArrowRight,
} from "lucide-react";

const ICONS = [Store, ListChecks, ListChecks, Camera, AlertTriangle, CheckCircle2, UserCheck, UserCheck, FileSignature, FileSignature];
const STEP_LINKS = ["/stores", "/checklist", "/stores", "/stores", "/findings", "/stores", "/findings", "/follow-up", "/audits", "/audits"];

export default function FlowPage() {
  const { activeAuditId } = useApp();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const steps = Array.from({ length: 10 }, (_, i) => ({
    id: i + 1,
    icon: ICONS[i],
    title: t(`flow.steps.s${i + 1}_title`),
    desc: t(`flow.steps.s${i + 1}_desc`),
    to: STEP_LINKS[i],
  }));
  return (
    <div data-testid="flow-page">
      <section className="hero-night text-white">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-12">
          <div className="canales-overline text-stone-300">{t("flow.title")}</div>
          <h1 className="font-display text-4xl md:text-6xl mt-2 leading-[1.05]">{t("flow.hero_title")}</h1>
          <p className="text-stone-300 mt-3 max-w-2xl">{t("flow.hero_desc")}</p>
          {activeAuditId && (
            <Button className="brand-button mt-6" onClick={() => navigate(`/audit/${activeAuditId}`)} data-testid="continue-active-audit">
              {t("flow.continue_active")} <ArrowRight size={14} className="ml-1.5" />
            </Button>
          )}
        </div>
      </section>

      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {steps.map((s, i) => (
            <Card key={s.id} className="canales-card p-5 fade-up" style={{ animationDelay: `${i * 30}ms` }} data-testid={`flow-step-${s.id}`}>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-xl bg-[#E5EBFA] text-[#1E3A8A] flex items-center justify-center font-display text-sm font-bold shrink-0">
                  {String(s.id).padStart(2, "0")}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <s.icon size={14} className="text-stone-700" />
                    <h3 className="font-semibold text-sm">{s.title}</h3>
                  </div>
                  <p className="text-xs text-stone-600 mt-1.5 leading-relaxed">{s.desc}</p>
                  <Link
                    to={s.to}
                    className="inline-flex items-center gap-1 mt-3 text-xs font-semibold text-[#1E3A8A] hover:underline"
                  >
                    {t("flow.go_step")} <ArrowRight size={12} />
                  </Link>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
